/**
 * Memoria de la última respuesta de las pantallas de Inicio y de la cabecera: al volver a Inicio (o al ingresar) se pinta
 * de inmediato lo último que se vio y se actualiza en segundo plano, en vez de mostrar huecos que luego se llenan y saltan.
 * Solo vive en la memoria de la pestaña y se vacía al cambiar de usuario.
 */
import { leerSesion } from "./api.ts";

const memoria = new Map<string, unknown>();
let dueno = "";
const revisar = () => { const u = leerSesion()?.usuario.id ?? ""; if (u !== dueno) { memoria.clear(); dueno = u; } };

export function leerCache<T>(clave: string): T | undefined { revisar(); return memoria.get(clave) as T | undefined; }
export function guardarCache<T>(clave: string, valor: T): T { revisar(); memoria.set(clave, valor); return valor; }
